<template>
    <div v-if="centro">
        <!-- BEGIN: Data List -->
        <h2 class="intro-y text-lg font-medium p-8 pb-0 text-center text-gray-700"><span class="text-3xl text-blue-700">{{centro.config.EMPRESA.nombre_de_la_empresa}}</span><br>{{centro.nombre_del_centro}}</h2>
        <div class="grid grid-cols-12 gap-6 mt-5" v-if="empresaVisible">
            <div class="intro-y col-span-12 flex flex-wrap sm:flex-no-wrap items-center mt-2">
                <Tippy tag="img" alt="Empresas" class="opacity-50 rounded-full mr-4" :src="require(`@/assets/images/businessman.svg`)" :content="`Empresas`" />
                <h2 class="intro-y text-lg font-medium">EMPRESA</h2>
            </div>
            <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
                <control-list :files="centro.config.EMPRESA.data[0].childs" :mostrar_resumen="mostrar_resumen" :last_24h="last_24h" :solo_pendientes_revision="solo_pendientes_revision"></control-list>
            </div>
        </div>
        <!-- END: Data List -->
        <!-- BEGIN: Data List -->
        <div class="grid grid-cols-12 gap-6 mt-5" v-if="empleadosFiltrados.length">
            <div class="intro-y col-span-12 flex flex-wrap sm:flex-no-wrap items-center mt-2">
                <Tippy tag="img" alt="Empresas" class="opacity-50 rounded-full mr-4" :src="require(`@/assets/images/businessman2.svg`)" :content="`Empleados`" />
                <h2 class="intro-y text-lg font-medium ">EMPLEADOS</h2>
                <!-- BEGIN: Inbox Filter -->
                <div class="intro-y flex flex-col-reverse sm:flex-row items-center ml-auto">
                    <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
                        <SearchIcon class="w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700 dark:text-gray-300" />
                        <input v-model="search.nombre_empleado" type="text" class="input w-full sm:w-64 box px-10 text-gray-700 dark:text-gray-300 placeholder-theme-13" placeholder="Filtrar por nombre..." />
                    </div>
                </div>
                <!-- END: Inbox Filter -->
            </div>
            <div class="intro-y col-span-12 ">
                <div v-for="(empleado, index) in empleadosFiltrados" :key="index" class="overflow-auto lg:overflow-visible mb-2 rounded-xl p-2 bg-blue-100 border-2 border-blue-200">
                    <h2 @click="toggle('empleado', empleado)" class="cursor-pointer intro-y text-lg font-medium m-2 flex items-center justify-between">
                        <span class="w-full block">{{empleado.nombre_y_apellidos}}</span>
                        <span v-if="badgePendientes(empleado)" class="text-red-500 text-xs  flex-shrink-0">{{badgePendientes(empleado)}} Documentos pendientes</span>
                        <ChevronDownIcon v-if="!toggledItems['empleado_' + empleado.num]" class="w-4 h-4 mr-2" />
                        <ChevronUpIcon v-if="toggledItems['empleado_' + empleado.num]" class="w-4 h-4 mr-2" />
                    </h2>
                    <small class="text-blue-700 pl-3 cursor-pointer" @click="verInfo('empleado', empleado)">Ver información</small>
                    <control-list v-if="toggledItems['empleado_' + empleado.num]" :files="empleado.data[0].childs" :mostrar_resumen="mostrar_resumen" :last_24h="last_24h" :solo_pendientes_revision="solo_pendientes_revision"></control-list>
                </div>
            </div>
        </div>
        <!-- END: Data List -->
        <!-- BEGIN: Data List -->
        <div class="grid grid-cols-12 gap-6 mt-5" v-if="subcontratasFiltradas.length">
            <div class="intro-y col-span-12 flex flex-wrap sm:flex-no-wrap items-center mt-2">
                <Tippy tag="img" alt="Empresas" class="opacity-50 rounded-full mr-4" :src="require(`@/assets/images/businessman3.svg`)" :content="`Subcontratas`" />
                <h2 class="intro-y text-lg font-medium w-full ">SUBCONTRATAS</h2>
                <!-- BEGIN: Inbox Filter -->
                <div class="intro-y flex flex-col-reverse sm:flex-row items-center mr-4 flex-shrink-0">
                    <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
                        <InboxIcon class="w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700 dark:text-gray-300" />
                        <select v-model="search.tipo" class="input w-full sm:w-64 box px-10 text-gray-700 dark:text-gray-300 placeholder-theme-13">
                            <option value="">Filtrar por tipo...</option>
                            <option value="AUTONOMO">Autónomo</option>
                            <option value="EMPRESA">Empresa</option>
                        </select>
                    </div>
                </div>
                <!-- END: Inbox Filter -->
                <!-- BEGIN: Inbox Filter -->
                <div class="intro-y flex flex-col-reverse sm:flex-row items-center flex-shrink-0 ">
                    <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
                        <SearchIcon class="w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700 dark:text-gray-300" />
                        <input v-model="search.nombre_subcontrata" type="text" class="input w-full sm:w-64 box px-10 text-gray-700 dark:text-gray-300 placeholder-theme-13" placeholder="Filtrar por subcontrata..." />
                    </div>
                </div>
                <!-- END: Inbox Filter -->
            </div>
            <div class="intro-y col-span-12 ">
                <div v-for="(subcontrata, index) in subcontratasFiltradas" :key="index" class="overflow-auto lg:overflow-visible mb-2 rounded-xl p-2 bg-blue-100 border-2 border-blue-200">
                    <h2 @click="toggle('subcontrata', subcontrata)" class="cursor-pointer intro-y text-lg font-medium m-2 flex items-center justify-between">
                        <span v-if="subcontrata.tipo == 'AUTONOMO'" class="w-full block">{{subcontrata.nombre_y_apellidos}} - AUTONOMO</span>
                        <span v-if="subcontrata.tipo == 'EMPRESA'" class="w-full block">{{subcontrata.nombre_de_la_empresa}} - EMPRESA</span>
                        <span v-if="badgePendientes(subcontrata)" class="text-red-500 text-xs  flex-shrink-0">{{badgePendientes(subcontrata)}} Documentos pendientes</span>
                        <ChevronDownIcon v-if="!toggledItems['subcontrata_' + subcontrata.num]" class="w-4 h-4 ml-2 flex-shrink-0" />
                        <ChevronUpIcon v-if="toggledItems['subcontrata_' + subcontrata.num]" class="w-4 h-4 ml-2 flex-shrink-0" />
                    </h2>
                    <small class="text-blue-700 pl-3 cursor-pointer" @click="verInfo('subcontrata', subcontrata)">Ver información</small>
                    <control-list :actual_depth="3" v-if="toggledItems['subcontrata_' + subcontrata.num]" :files="subcontrata.data[0].childs" :mostrar_resumen="mostrar_resumen" :last_24h="last_24h" :solo_pendientes_revision="solo_pendientes_revision"></control-list>
                    <div v-if="subcontrata.empleados && toggledItems['subcontrata_' + subcontrata.num] && empleadosSubcontrataFiltrados(subcontrata).length" class="m-2 ">
                        <h2 class="intro-y text-lg font-medium mt-4 mb-6 mx-2 flex items-center justify-between">
                            EMPLEADOS
                        </h2>
                        <div v-for="(empleado, index) in empleadosSubcontrataFiltrados(subcontrata)" :key="index" class="overflow-auto lg:overflow-visible mb-2 rounded-xl p-2 bg-orange-100 border-2 border-orange-200">
                            <h2 @click="toggle('empleado', empleado)" class="cursor-pointer intro-y text-lg font-medium m-2 flex items-center justify-between">
                                <span class="w-full block">{{empleado.nombre_y_apellidos}}</span>
                                <span v-if="badgePendientes(empleado)" class="text-red-500 text-xs  flex-shrink-0">{{badgePendientes(empleado)}} Documentos pendientes</span>
                                <ChevronDownIcon v-if="!toggledItems['empleado_' + empleado.num]" class="w-4 h-4 ml-2 flex-shrink-0" />
                                <ChevronUpIcon v-if="toggledItems['empleado_' + empleado.num]" class="w-4 h-4 ml-2 flex-shrink-0" />
                            </h2>
                            <small class="text-blue-700 pl-3 cursor-pointer" @click="verInfo('empleado', empleado)">Ver información</small>
                            <control-list :actual_depth="3" v-if="toggledItems['empleado_' + empleado.num]" :files="empleado.data[0].childs" :mostrar_resumen="mostrar_resumen" :last_24h="last_24h" :solo_pendientes_revision="solo_pendientes_revision"></control-list>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- BEGIN: Data List -->
        <!-- BEGIN: Data List -->
        <div class="grid grid-cols-12 gap-6 mt-5" v-if="maquinariasFiltradas.length">
            <div class="intro-y col-span-12 flex flex-wrap sm:flex-no-wrap items-center mt-2">
                <Tippy tag="img" alt="Empresas" class="opacity-50 rounded-full mr-4" :src="require(`@/assets/images/maquinaria.svg`)" :content="`Maquinaria`" />
                <h2 class="intro-y text-lg font-medium ">MAQUINARIA</h2>
                <!-- BEGIN: Inbox Filter -->
                <div class="intro-y flex flex-col-reverse sm:flex-row items-center ml-auto">
                    <div class="w-full sm:w-auto relative mr-auto mt-3 sm:mt-0">
                        <SearchIcon class="w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700 dark:text-gray-300" />
                        <input v-model="search.nombre_de_la_maquina" type="text" class="input w-full sm:w-64 box px-10 text-gray-700 dark:text-gray-300 placeholder-theme-13" placeholder="Filtrar por nombre..." />
                    </div>
                </div>
                <!-- END: Inbox Filter -->
            </div>
            <div class="intro-y col-span-12 ">
                <div v-for="(maquinaria, index) in maquinariasFiltradas" :key="index" class="overflow-auto lg:overflow-visible mb-2 rounded-xl p-2 bg-blue-100 border-2 border-blue-200">
                    <h2 @click="toggle('maquinaria', maquinaria)" class="cursor-pointer intro-y text-lg font-medium m-2 flex items-center justify-between">
                        <span class="w-full block">{{maquinaria.nombre_de_la_maquina}}</span>
                        <span v-if="badgePendientes(maquinaria)" class="text-red-500 text-xs  flex-shrink-0">{{badgePendientes(maquinaria)}} Documentos pendientes</span>
                        <ChevronDownIcon v-if="!toggledItems['maquinaria_' + maquinaria.num]" class="w-4 h-4 mr-2" />
                        <ChevronUpIcon v-if="toggledItems['maquinaria_' + maquinaria.num]" class="w-4 h-4 mr-2" />
                    </h2>
                    <small class="text-blue-700 pl-3 cursor-pointer" @click="verInfo('maquinaria', maquinaria)">Ver información</small>
                    <control-list v-if="toggledItems['maquinaria_' + maquinaria.num]" :files="maquinaria.data[0].childs" :mostrar_resumen="mostrar_resumen" :last_24h="last_24h" :solo_pendientes_revision="solo_pendientes_revision"></control-list>
                </div>
            </div>
        </div>
        <div v-if="modalInfo" class="fixed top-0 left-0 w-full h-full" style="z-index: 100;">
            <div class="absolute top-0 left-0 w-full h-full bg-black opacity-50" @click="modalInfo = null">
                <div class="h-32"></div>
            </div>
            <div class="absolute top-0 left-0 w-full h-full flex justify-center items-center pointer-events-none">
                <div class="relative max-w-screen-xl bg-white p-8 overflow-auto pointer-events-auto" style="max-height: 90%;">
                    <XIcon @click="modalInfo = null" class="absolute top-0 right-0 m-4 w-4 h-4 flex-shrink-0 cursor-pointer" />
                    <div v-if="modalInfo.tableName == 'empleados' || modalInfo.tipo == 'AUTONOMO'">
                        <h1 class="text-lg font-bold">{{modalInfo.nombre_y_apellidos}}</h1>
                        <p><strong>DNI:</strong><br><span class="pl-3"></span> {{modalInfo.dni}}</p>
                        <p><strong>Relación de actividades a desempeñar:</strong><br><span class="pl-3"></span> {{modalInfo.relacion_de_actividades_a_desempenar}}</p>
                    </div>
                    <div v-if="modalInfo.tipo == 'EMPRESA'">
                        <h1 class="text-lg font-bold">{{modalInfo.nombre_de_la_empresa}}</h1>
                        <p><strong>CIF:</strong><br><span class="pl-3"></span> {{modalInfo.cif}}</p>
                        <p><strong>Dirección:</strong><br><span class="pl-3"></span> {{modalInfo.direccion}}</p>
                        <p><strong>Teléfono:</strong><br><span class="pl-3"></span> {{modalInfo.telefono}}</p>
                        <p><strong>Persona de contacto en materia de PRL:</strong><br><span class="pl-3"></span> {{modalInfo.persona_de_contacto_en_materia_de_prl}}</p>
                        <p><strong>Mail:</strong><br><span class="pl-3"></span> {{modalInfo.mail}}</p>
                    </div>
                    <div v-if="modalInfo.tableName == 'maquinaria'">
                        <h1 class="text-lg font-bold">{{modalInfo.nombre_de_la_maquina}}</h1>
                    </div>
                </div>
            </div>
        </div>
        <!-- END: Data List -->
        <modal :data="{ 'id':'ok-confirmation-modal', 'title':'Guardado', 'text':'Los archivos han sido subidos', 'icon':'check'}"></modal>
        <modal :data="{ 'id':'error-confirmation-modal', 'title':'Error', 'text':'Ha ocurrido un error en la subida', 'icon':'x'}"></modal>
    </div>
</template>
<script>
import ControlList from "@/components/ControlList";
import Modal from "@/global-components/Modal";
import Vue from "vue";

export default {
    props: ["mostrar_resumen", "last_24h", "solo_pendientes_revision"],
    components: {
        ControlList,
        Modal
    },
    data() {
        return {
            search: {
                tipo: '',
                nombre_empleado: '',
                nombre_subcontrata: '',
                nombre_de_la_maquina: ''
            },
            centro: null,
            toggledItems: {},
            modalInfo: null
        }
    },
    mounted() {
        window.bus.$on('dataReloaded', () => {
            this.centro = this.$d().user.centro;
        });
        this.centro = this.$d().user.centro;
    },
    computed: {
        empresaVisible() {
            if(!this.centro || !this.centro.config || !this.centro.config.EMPRESA) return false;
            if(!this.solo_pendientes_revision) return true;
            return this.tienePendientesRevision(this.centro.config.EMPRESA.data[0].childs);
        },
        empleadosFiltrados() {
            if(!this.centro || !this.centro.config || !this.centro.config.EMPLEADOS) return [];
            return this.filter_empleados(this.centro.config.EMPLEADOS);
        },
        subcontratasFiltradas() {
            if(!this.centro || !this.centro.config || !this.centro.config.SUBCONTRATAS) return [];
            return this.filter_subcontratas(this.centro.config.SUBCONTRATAS);
        },
        maquinariasFiltradas() {
            if(!this.centro || !this.centro.config || !this.centro.config.MAQUINARIA) return [];
            return this.filter_maquinarias(this.centro.config.MAQUINARIA);
        }
    },
    methods: {
        tienePendientesRevision(nodes) {
            if(!nodes || !(Symbol.iterator in Object(nodes))) return false;
            for(const node of nodes) {
                if(node.files && node.files[node.order] && node.files[node.order].state === '1') return true;
                if(node.childs && this.tienePendientesRevision(node.childs)) return true;
                if(node.data && this.tienePendientesRevision(node.data)) return true;
            }
            return false;
        },
        contarPendientesRevision(nodes) {
            if(!nodes || !(Symbol.iterator in Object(nodes))) return 0;
            let total = 0;
            for(const node of nodes) {
                if(node.files && node.files[node.order] && node.files[node.order].state === '1') total++;
                if(node.childs) total += this.contarPendientesRevision(node.childs);
                if(node.data) total += this.contarPendientesRevision(node.data);
            }
            return total;
        },
        itemTienePendientes(item) {
            if(!item) return false;
            if(item.data && this.tienePendientesRevision(item.data)) return true;
            if(item.empleados && item.empleados.some(emp => this.itemTienePendientes(emp))) return true;
            return false;
        },
        contarItemPendientes(item) {
            if(!item) return 0;
            let total = 0;
            if(item.data) total += this.contarPendientesRevision(item.data);
            if(item.empleados) {
                for(const emp of item.empleados) total += this.contarItemPendientes(emp);
            }
            return total;
        },
        badgePendientes(item) {
            if(this.solo_pendientes_revision) return this.contarItemPendientes(item);
            return this.emptyFiles(item);
        },
        empleadosSubcontrataFiltrados(subcontrata) {
            if(!subcontrata.empleados) return [];
            if(!this.solo_pendientes_revision) return subcontrata.empleados;
            return subcontrata.empleados.filter(emp => this.itemTienePendientes(emp));
        },
        filter_empleados: function(list) {
            return list.filter(item => {
                if(this.solo_pendientes_revision && !this.itemTienePendientes(item)) return false;
                if(!this.search.nombre_empleado) return true;
                return item.nombre_y_apellidos.toLowerCase().search(this.search.nombre_empleado.toLowerCase()) !== -1;
            });
        },
        filter_maquinarias: function(list) {
            return list.filter(item => {
                if(this.solo_pendientes_revision && !this.itemTienePendientes(item)) return false;
                if(!this.search.nombre_de_la_maquina) return true;
                return item.nombre_de_la_maquina.toLowerCase().search(this.search.nombre_de_la_maquina.toLowerCase()) !== -1;
            });
        },
        filter_subcontratas: function(list) {
            return list.filter(item => {
                if(this.solo_pendientes_revision && !this.itemTienePendientes(item)) return false;
                let result = true;
                if(item.tipo == 'AUTONOMO' && this.search.nombre_subcontrata) {
                    result = item.nombre_y_apellidos.toLowerCase().search(this.search.nombre_subcontrata.toLowerCase()) !== -1;
                }
                else if(item.tipo == 'EMPRESA' && this.search.nombre_subcontrata) {
                    result = item.nombre_de_la_empresa.toLowerCase().search(this.search.nombre_subcontrata.toLowerCase()) !== -1;
                }
                if(!this.search.tipo) return result;
                return result && item.tipo == this.search.tipo;
            });
        },
        verInfo(tipo, datos) {
            this.modalInfo = datos;
        },
        toggle(name, item) {
            // El doble !! es para convertir indefinidos a boolean. !undefined => !true => false. El tercero es para hacer el toggle.
            Vue.set(this.toggledItems, name + '_' + item.num, !!!this.toggledItems[name + '_' + item.num])
        },
        closeModal() {
            cash("#ok-confirmation-modal").modal("show");
        }
    }
}
</script>